import useAnalytics from 'core/hooks/useAnalytics';
import { useEffect, useRef } from 'react';

import { EVENT_NAMES } from '../../constants/eventNames';
import { useAnalyticsFilters } from '../../contexts/AnalyticsFiltersContext';

function useTeacherAnalyticsOpenedEvent(): void {
  const { trackEvent } = useAnalytics();
  const { filtersReady, isMockMode, selectedClass, selectedTimePeriod } = useAnalyticsFilters();
  const hasTrackedOpenedRef = useRef<boolean>(false);

  useEffect(() => {
    // `loading` turns false one render before the provider applies ?class= and ?period=,
    // so gating on it would report the default filters on a deep link or a reload.
    if (!filtersReady || hasTrackedOpenedRef.current) return;
    hasTrackedOpenedRef.current = true;
    trackEvent(EVENT_NAMES.IA_TEACHER_ANALYTICS_OPENED, {
      class_id: selectedClass.value,
      period: selectedTimePeriod.value,
      mock_mode: isMockMode,
    })
      .then((result: unknown) => {
        // A null result means analytics was not hydrated yet, so the latch reopens for the retry.
        if (result === null) hasTrackedOpenedRef.current = false;
      })
      .catch((error: unknown) => console.error('Analytics tracking failed:', error));
  }, [filtersReady, isMockMode, selectedClass.value, selectedTimePeriod.value, trackEvent]);
}

export default useTeacherAnalyticsOpenedEvent;
